var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17484 27.8328L0.666504 21.3245L3.23317 18.7578L7.129 22.6536L14.9207 14.862L17.4873 17.4745L7.17484 27.8328ZM7.17484 13.1661L0.666504 6.65781L3.23317 4.09115L7.129 7.98698L14.9207 0.195312L17.4873 2.80781L7.17484 13.1661ZM20.8332 24.1661V20.4995H37.3332V24.1661H20.8332ZM20.8332 9.49948V5.83281H37.3332V9.49948H20.8332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecklist);
export default __webpack_public_path__ + "static/media/icon_checklist.36fc09c8ce6b0650de8228ae0026a664.svg";
export { ForwardRef as ReactComponent };